import { SkipTraceFileTypeENUM } from '../../utils/skipTraceFileHeaders';
import nameMailingSeparateFieldsExample from '../../assets/name-mailing-separate-fields-example.png';

export type HelpQuestionOptionType = {
  id: string;
  label: string;
  nextQuestionId?: string;
};

export type HelpQuestionType = {
  id: string;
  text: string;
  options: HelpQuestionOptionType[];
  isResult?: boolean;
  isMessage?: boolean;
  recommendedTypeLabel?: string;
  skipTraceType?: string;
  exampleImage?: string;
  exampleImageAlt?: string;
};

export const HELP_QUESTIONS: Record<string, HelpQuestionType> = {
  phoneOrEmail: {
    id: 'phoneOrEmail',
    text: 'Are you looking to gain phone numbers and/or emails?',
    options: [
      { id: 'yes', label: 'Yes', nextQuestionId: 'hasNameAndMailing' },
      { id: 'no', label: 'No', nextQuestionId: 'whatLookingFor' },
    ],
  },
  hasNameAndMailing: {
    id: 'hasNameAndMailing',
    text: 'Do you have first/last name and mailing address in separate fields?',
    exampleImage: nameMailingSeparateFieldsExample,
    exampleImageAlt:
      'Example spreadsheet with first name, last name, and mailing address in separate columns',
    options: [
      { id: 'yes', label: 'Yes', nextQuestionId: 'resultOwnerMailing' },
      { id: 'no', label: 'No', nextQuestionId: 'hasPropertyAddresses' },
    ],
  },
  hasPropertyAddresses: {
    id: 'hasPropertyAddresses',
    text: 'Do you have property addresses?',
    options: [
      { id: 'yes', label: 'Yes', nextQuestionId: 'resultPropertyAddress' },
      { id: 'no', label: 'No', nextQuestionId: 'insufficientData' },
    ],
  },
  insufficientData: {
    id: 'insufficientData',
    text: "It seems like you don't have enough data for skiptracing.",
    isMessage: true,
    options: [],
  },
  whatLookingFor: {
    id: 'whatLookingFor',
    text: 'What are you looking for?',
    options: [
      {
        id: 'phoneForOwner',
        label: 'I have phone numbers,\nlooking for owner info',
        nextQuestionId: 'resultReversePhone',
      },
      {
        id: 'emailForOwner',
        label: 'I have emails,\nlooking for owner info',
        nextQuestionId: 'resultReverseEmail',
      },
      {
        id: 'scrubLitigatorOrDnc',
        label: 'I am looking to scrub out litigator or DNC',
        nextQuestionId: 'whatToScrub',
      },
    ],
  },
  whatToScrub: {
    id: 'whatToScrub',
    text: 'What you want to scrub?',
    options: [
      {
        id: 'litigator',
        label: 'Litigator Scrub',
        nextQuestionId: 'resultLitigatorScrub',
      },
      {
        id: 'dnc',
        label: 'DNC Scrub',
        nextQuestionId: 'resultDncScrub',
      },
    ],
  },
  resultOwnerMailing: {
    id: 'resultOwnerMailing',
    text: 'Based on your answers, we recommend:',
    isResult: true,
    recommendedTypeLabel: SkipTraceFileTypeENUM.OWNER_MAILING_ADDRESS,
    skipTraceType: SkipTraceFileTypeENUM.OWNER_MAILING_ADDRESS,
    options: [],
  },
  resultPropertyAddress: {
    id: 'resultPropertyAddress',
    text: 'Based on your answers, we recommend:',
    isResult: true,
    recommendedTypeLabel: SkipTraceFileTypeENUM.PROPERTY_ADDRESS,
    skipTraceType: SkipTraceFileTypeENUM.PROPERTY_ADDRESS,
    options: [],
  },
  resultReversePhone: {
    id: 'resultReversePhone',
    text: 'Based on your answers, we recommend:',
    isResult: true,
    recommendedTypeLabel: SkipTraceFileTypeENUM.PHONE,
    skipTraceType: SkipTraceFileTypeENUM.PHONE,
    options: [],
  },
  resultReverseEmail: {
    id: 'resultReverseEmail',
    text: 'Based on your answers, we recommend:',
    isResult: true,
    recommendedTypeLabel: SkipTraceFileTypeENUM.EMAIL,
    skipTraceType: SkipTraceFileTypeENUM.EMAIL,
    options: [],
  },
  resultLitigatorScrub: {
    id: 'resultLitigatorScrub',
    text: 'Based on your answers, we recommend:',
    isResult: true,
    recommendedTypeLabel: SkipTraceFileTypeENUM.BLACKLISTED,
    skipTraceType: SkipTraceFileTypeENUM.BLACKLISTED,
    options: [],
  },
  resultDncScrub: {
    id: 'resultDncScrub',
    text: 'Based on your answers, we recommend:',
    isResult: true,
    recommendedTypeLabel: SkipTraceFileTypeENUM.DNC,
    skipTraceType: SkipTraceFileTypeENUM.DNC,
    options: [],
  },
};

export const FIRST_HELP_QUESTION_ID = 'phoneOrEmail';
